import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User clicked an announcement action control',
  name: 'announcement_action_clicked',
  params: [
    {
      description: 'Internal announcement name',
      name: 'name',
      required: true,
      type: 'string',
    },
    {
      description: 'Surface where the announcement was shown',
      name: 'surface',
      required: true,
      type: 'enum',
      values: ['global', 'assetDetails', 'canvas', 'canvasNullState', 'canvasChatComposer', 'boards', 'plans', 'news'],
    },
    {
      description: 'Announcement id',
      name: 'announcement_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Action type',
      name: 'action_type',
      required: true,
      type: 'enum',
      values: ['button', 'link'],
    },
    {
      description: 'Action label shown to the user',
      name: 'action_label',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
